import React from 'react'
import classNames from 'classnames'
import withStyles from '@material-ui/core/styles/withStyles'
import AppBar from './AppBar'
import MessagesDrawer from '../MessagesDrawer'
import AppMenuDrawer from '../AppMenuDrawer'

import BaseRoutes from '../../routes/BaseRoutes'
import withRouter from 'react-router-dom/withRouter'
import { connect } from 'react-redux'
import { drawerActions } from '../../actions'
import SearchBarLayout from './SearchBar'
import { googleAnalytics } from '../../utils'
import AIAssistantModal from '../../components/AIAssistantModal'
import AIOnboardingTour from '../../components/AIOnboardingTour'
import Query from 'react-apollo/Query'
import { userQueries } from '../../graphql/queries'
import { FEATURES, initFeatureFlags, isFeatureEnabled } from '../../services/featureFlags'
import * as authService from '../../services/auth'
import { INFORMED_IA_ENTRY } from '../../utils/contentNavigation'

const styles = (theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
})

const Wrapper = withStyles({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    boxSizing: 'border-box',
  },
})(({ classes, children, ...rest }) => {
  return (
    <div
      {...rest}
      className={classNames(classes.root, 'transition-item list-page')}
      style={{ background: '#f7f7f7' }}
    >
      {children}
    </div>
  )
})

const ChildrenWrapper = withStyles({
  childrenWrapper: {
    width: '100%',
    height: 'calc(100% - 55px)',
    '-webkit-overflow-scrolling': 'touch',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '@media only screen and (max-width: 900px) and (orientation: landscape)': {
      height: 'calc(100% - 47px)',
    },
  },
})(({ classes, children }) => {
  return (
    <div id={'infinite-scroll-wrapper'} className={classNames(classes.childrenWrapper)}>
      {children}
    </div>
  )
})

class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      aiAssistantOpen: false,
      continueOnboarding: false,
      onboardingResumeToken: 0,
      featureFlagsReady: false,
    }
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  getMainContentStyles = () => {
    const { safeArea = true } = this.props
    const styles = {}
    if (!safeArea) {
      styles.padding = 0
    }
    Object.freeze(styles)
    return styles
  }
  toggleDrawer = (open) => () => {
    this.setState({
      open,
    })
  }

  handleDrawerMessageClose = () => {
    this.setState({ messagesOpen: false })
  }

  showSearchBar = () => {
    const { location = {} } = this.props
    const { pathname } = location

    const pathNames = [
      '/duvidas-frequentes',
      '/tutorial',
      '/curadores',
      '/termos-de-uso',
      '/politica-de-privacidade',
      '/cid',
      '/medicamentos',
    ]

    return !pathNames.find((path) => path === pathname)
  }

  toggleDrawerMessage = (messagesOpen) => () => {
    this.setState({
      messagesOpen,
    })
    googleAnalytics('acao_boletim_item_janela_del')
  }

  handleDrawerMessageOpen = () => {
    googleAnalytics('acao_boletim', 'home', 'Se clica para abrir menu boletins', 'Clique')
    this.setState({ messagesOpen: true })
  }

  componentDidMount() {
    window.addEventListener('message', this.handleIframeMessage)
    initFeatureFlags()
      .then(() => this.setState({ featureFlagsReady: true }))
      .catch(() => this.setState({ featureFlagsReady: true }))
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeMessage)
  }

  handleIframeMessage = (event) => {
    if (!event.data) return

    if (event.data.type === 'CLOSE_AI_ASSISTANT') {
      this.handleAIAssistantClose()
      return
    }

    if (event.data.type === 'AI_ONBOARDING_BACK') {
      if (!this.isTrustedAIAssistantOrigin(event.origin)) return
      this.setState({
        aiAssistantOpen: false,
        continueOnboarding: false,
        onboardingResumeToken: Date.now(),
      })
      return
    }

    if (event.data.type === 'OPEN_CONTENT' && event.data.contentId) {
      if (!this.isTrustedAIAssistantOrigin(event.origin)) return

      const contentId = String(event.data.contentId).trim()
      if (!contentId) return

      this.handleAIAssistantClose()
      this.props.history.push({
        pathname: `/conteudo/${encodeURIComponent(contentId)}`,
        search: `?from=${INFORMED_IA_ENTRY}`,
        state: { from: INFORMED_IA_ENTRY, contexto: INFORMED_IA_ENTRY },
      })
    }
  }

  isTrustedAIAssistantOrigin = (origin) => {
    const aiUrl = String(process.env.REACT_APP_AI_ASSISTANT_URL || '')
      .replace(/^['"]|['"]$/g, '')
      .trim()
    if (!aiUrl || !origin) return false

    try {
      return origin === new URL(aiUrl).origin
    } catch (error) {
      return false
    }
  }

  handleAIAssistantOpen = (options) => {
    this.setState({
      aiAssistantOpen: true,
      continueOnboarding: !!(options && options.continueOnboarding === true),
    })
  }

  handleAIAssistantClose = () => {
    this.setState({ aiAssistantOpen: false, continueOnboarding: false })
  }

  renderLayoutContent = (user = {}) => {
    const { classes, location } = this.props
    const showSearchBar = this.showSearchBar()
    const mainContentStyles = this.getMainContentStyles()
    const aiAssistantEnabled = isFeatureEnabled(FEATURES.AI_ASSISTANT, user)
    const onAIAssistantOpen = aiAssistantEnabled ? this.handleAIAssistantOpen : undefined

    return (
      <Wrapper>
        {location.pathname !== '/tutorial' && !this.state.aiAssistantOpen && (
          <AppBar
            handleMenuOpen={this.props.openMenuDrawer}
            handleDrawerMessageOpen={this.handleDrawerMessageOpen}
            onAIAssistantOpen={onAIAssistantOpen}
          />
        )}
        {!this.state.open && (
          <MessagesDrawer
            classes={classes}
            open={this.state.messagesOpen}
            onClose={this.toggleDrawerMessage(false)}
            onOpen={this.toggleDrawerMessage(true)}
          />
        )}
        {!this.state.messagesOpen && (
          <AppMenuDrawer
            classes={classes}
            open={this.props.menuDrawerOpen}
            onClose={this.props.closeMenuDrawer}
            onOpen={this.props.openMenuDrawer}
          />
        )}
        <AIAssistantModal
          open={aiAssistantEnabled && this.state.aiAssistantOpen}
          continueOnboarding={this.state.continueOnboarding}
        />
        <AIOnboardingTour
          enabled={aiAssistantEnabled}
          blocked={this.state.aiAssistantOpen}
          resumeToken={this.state.onboardingResumeToken}
          onOpenAssistant={this.handleAIAssistantOpen}
        />
        <main className={classes.content} style={mainContentStyles}>
          <div className={classNames(classes.toolbar, 'hidden-print')} />
          <ChildrenWrapper>
            {!!showSearchBar && (
              <SearchBarLayout onAIAssistantOpen={onAIAssistantOpen} />
            )}
            <BaseRoutes />
          </ChildrenWrapper>
        </main>
      </Wrapper>
    )
  }

  render() {
    return (
      <Query
        query={userQueries.GET_USER}
        fetchPolicy={'cache-and-network'}
        onCompleted={(data = {}) => {
          const { email, userid } = data.user || {}
          if (email) {
            authService.syncPostHogIdentity({ email, userId: userid })
          }
        }}
      >
        {({ data = {} }) => this.renderLayoutContent(data.user || {})}
      </Query>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    menuDrawerOpen: state.drawer.menuDrawerOpen,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openMenuDrawer: () => {
      dispatch(drawerActions.openMenuDrawer())
    },
    closeMenuDrawer: () => {
      dispatch(drawerActions.closeMenuDrawer())
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Layout))
)
